const state = () => ({
	baseInfo: new Object(),	
	modalData: {
		modalType: "",
		isShowModal: false,
		chapter: Object,
		editDescription: '',
		delType: 'chapter',
		book_id: '',
		chapter_number: ''
	},
	tagArray: ['Romance','LGBT','Action','Youth','Adventure','Drama','Comedy','Horror','Fantasy','18+','Suspense','Others'],
	statusText: ['Set for Release','To examine','Released','Error'],
	chapterList: new Array(),
	axiosData: new Object(),
	uploadType: ''
})

// getters
const getters = {
	
}

// actions
const actions = {
	renderBaseInfo({ commit, state }, bookDetail) {
		commit('renderBaseInfoFn', bookDetail)
	},
	renderChapterList({ commit, state }, chapterList) {
		commit('renderChapterListFn', chapterList)
	},
	openModal({ commit, state }, {type,chapter,book_id,chapter_number}) {
		commit('openModalFn')
		if (type === 'editChaptingDescription') {
			commit('initDescription', chapter)
			return
		} 
		if (type === 'addChapting') {
			commit('addChapter')
			return
		}
		if (type === 'reviewTips') {
			commit('openReviewTips')
			return
		}
		if (type === 'delDialog') {
			state.modalData.modalType = 'delDialog'
			state.modalData.book_id = book_id
			state.modalData.chapter_number = chapter_number
		}
	},
	okCloseModal({ commit, state }) {
		commit('closeModalFn')
	},
	cancleModal({ commit, state }) {
		commit('closeModalFn')
		state.modalData.editDescription =  ''
	},
	uploadImgData({ commit, state }, uploadData) {
		commit('uploadImgDataFn', uploadData)
		commit('clickEvent')
	}
}

// mutations
const mutations = {
	renderBaseInfoFn(state, bookDetail) {
		bookDetail.tag = bookDetail.tag.split(',')
		bookDetail.tag = JSON.parse('[' + String(bookDetail.tag) + ']')
		const newTag = state.tagArray.filter((item,index) => {
			return bookDetail.tag.indexOf(index+1) !== -1 
		})
		bookDetail.tag_text = newTag
		state.baseInfo = bookDetail
	},
	renderChapterListFn(state,chapterList) {
		// console.log(chapterList)
		state.chapterList = chapterList
	},
	initDescription(state, chapter) {
		state.modalData.chapter = chapter
		state.modalData.editDescription = chapter.description
		state.modalData.modalType = 'editChaptingDescription'
	},
	updateDescription(state, value) {
		state.modalData.editDescription = value
	},
	saveDescriptionFn(state) {
		// 如果输入的是有效值 则更新 chapter 列表
		if (state.modalData.editDescription.length != 0) {
			const newChapterList = state.chapterList.find(item => {
				return item.id === state.modalData.chapter.id
			})
			newChapterList.description = state.modalData.editDescription
		}
	},
	addChapter(state) {
		state.modalData.modalType = 'addChapting'
	},
	addChapterFn(state, {chapter,book_id}) {
		const newData = {
			book_id: book_id,
			chapter_number: chapter.chapter_number,
			title: `Chapter${chapter.chapter_number}`,
			description: state.modalData.editDescription,
			status: 0,
			update_version: 0
		}
		if (!state.chapterList.length) {
			state.chapterList = []
		}
		state.chapterList.push(newData);
		state.baseInfo.total_chapter_count += 1
		state.modalData.editDescription = ''
	},
	openReviewTips(state) {
		state.modalData.modalType = 'reviewTips'
	},
	closeModalFn(state) {
		state.modalData.isShowModal = false;
	},
	openModalFn(state) {
		state.modalData.isShowModal = true;
	},
	delChapterFn(state, chapter_number) { // 同步页面数据更新
		state.chapterList = state.chapterList.filter(item => {
			return item.chapter_number !== chapter_number
		})
		if (state.baseInfo.total_chapter_count > 0) {
			state.baseInfo.total_chapter_count = state.baseInfo.total_chapter_count - 1
		} else {
			state.baseInfo.total_chapter_count = 0
		}
		state.modalData.isShowModal = false;
	},
	changeDelStatueFn(state) {
		state.isConfirm = true
	},
	editChapterFn(state, chapterInfor) {
		// 如果输入的是有效值 则更新 chapter 列表
		if (state.modalData.editDescription.length != 0) {
			const newChapterList = state.chapterList.find(item => {
				return item.id === state.modalData.chapter.id
			})
			newChapterList.description = state.modalData.editDescription
		}
	},
	uploadImgDataFn(state, {axiosData,uploadType}) {
		state.axiosData = axiosData
		state.uploadType = uploadType
	},
	clickEvent() {
		// IE浏览器
		if(!!window.ActiveXObject || "ActiveXObject" in window) {
			document.getElementById('upload_file').click();
		}else {
			var e = document.createEvent("MouseEvents");
			e.initEvent("click", true, true);
			document.getElementById('upload_file').dispatchEvent(e);
		}
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}